import { CreditCard } from "@/icons/CreditCard.tsx";
import useUserStore from "@/store/user.store.ts";
import { Alert, Button, Text } from "@mantine/core";
import { Link } from "react-router";

export function CreditsCard() {
  const { user } = useUserStore();

  if (!user) {
    return null;
  }

  if (user.credits > 1000) {
    return null;
  }

  const text =
    user.credits === 0
      ? "You have no credits left! Top-up now!"
      : "You have less than 1000 credits left!";

  return (
    <Alert
      title="Credits warning"
      bd="1px dashed teal.9"
      variant="light"
      color="teal"
      icon={<CreditCard size={40} />}
    >
      <div className="flex flex-col gap-4">
        <Text>{text}</Text>

        <Button
          component={Link}
          to="/billing"
          variant="outline"
          color="teal"
          size="sm"
        >
          Top up credits
        </Button>
      </div>
    </Alert>
  );
}
